import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaymentRoutingModule } from './payment-routing.module';
import { PaymentComponent } from './payment.component';
import { StripeComponent } from './stripe/stripe.component';


@NgModule({
  declarations: [
    PaymentComponent,
    StripeComponent
  ],
  imports: [
    CommonModule,
    PaymentRoutingModule
  ],exports:[
    PaymentComponent,
    StripeComponent
  ]
})
export class PaymentModule { }
